import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import chartImage from './images/chart.webp';
import medalImage from './images/medal.png';
import podiumImage from './images/podium.png';
import { NamedLink } from '../../../../components';

import css from './SectionSAChart.module.css';

const SectionSAChart = props => {
  const { rootClassName, className } = props;

  const classes = clsx(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionSAChart.title" />
        <br />
      </div>

      <div className={css.steps}>
        <div className={css.step}>
          <img src={chartImage} className={css.chart} alt="chart" />
        </div>

        <div className={css.step}>
          <img className={css.illustration} src={medalImage} alt="medal" />
          <img className={css.illustration} src={podiumImage} alt="podium" />

          <p></p>
          <p>
            <FormattedMessage id="SectionSAChart.Text" />
          </p>
        </div>
      </div>
      <div className={css.caption}>
        <FormattedMessage id="SectionSAChart.caption" />
      </div>
      <div className={css.stepButtonCTA}>
        <NamedLink name="AffiliateSignupPage" params={{ userType: 3, }} className={css.signUpButton}>
          <FormattedMessage id="SectionHeroSA.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

SectionSAChart.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionSAChart.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionSAChart;
